import React from 'react';
import { GripVerticalIcon, Icon } from 'smoothie';

import type { DragHandleProps } from './goalsWaterfallTypes';

export const DragHandle = ({
    setActivatorNodeRef,
    listeners,
    attributes,
    iconSize = 18,
}: DragHandleProps) => {
    const { onPointerDown: kitOnPointerDown, ...restListeners } = (listeners ??
        {}) as Record<string, unknown>;
    const runKitPointerDown =
        typeof kitOnPointerDown === 'function'
            ? (kitOnPointerDown as (e: unknown) => void)
            : undefined;

    return (
        <div
            ref={setActivatorNodeRef as React.RefCallback<HTMLDivElement>}
            {...(attributes as unknown as Record<string, unknown>)}
            {...restListeners}
            onPointerDown={(e) => {
                runKitPointerDown?.(e as never);
                e.stopPropagation();
            }}
            style={{
                cursor: 'grab',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                minWidth: 44,
                minHeight: 44,
                margin: -4,
                padding: 10,
                borderRadius: 8,
                touchAction: 'none',
                userSelect: 'none',
            }}
        >
            <Icon icon={GripVerticalIcon} size={iconSize} color="$gray1200" />
        </div>
    );
};
